import { useTranslation } from 'react-i18next';
import { Icon, Box, Typography, useTheme } from '../../../../base';

interface Props {
    isArchive: boolean;
}

const EmptyTasks = ({ isArchive }: Props) => {
    const theme = useTheme();
    const { t } = useTranslation();
    return (
        <Box
            sx={{
                p: 2,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Icon name="NoTasksIconBig" size={100} color={theme.palette.primary.main} />
            <Typography variant="h4">
                {t(
                    isArchive
                        ? 'dashboardPage.archiveIsEmpty'
                        : 'dashboardPage.noTasksAvailable'
                )}
            </Typography>
        </Box>
    );
};

export default EmptyTasks;
